import styled, { DefaultTheme } from 'styled-components'

import { COLUMN_HEADER_MIN_HEIGHT } from './linked-columns.constants'

const SWITCH_SELECTOR = '[data-component-id="Switch"]'

// Note: a Switch with a label pads its own row, which on top of the list gap spaced the switches far
// apart; they sit close together here, and the list gap only separates them from the selects
const getSwitchRows = (theme: DefaultTheme) => ({
  [`& > ${SWITCH_SELECTOR}`]: {
    paddingBottom: 0,
    paddingTop: 0,
  },
  [`& > ${SWITCH_SELECTOR} + ${SWITCH_SELECTOR}`]: {
    marginTop: `calc(${theme.space['8']} - ${theme.space['16']})`,
  },
})

// Note: an absolute child of the columns grid placed in its last column, so that grid column is the
// containing block - the island sits in the margin right of the list panel. `&&` beats the grid's
// `> * { height }` rule
export const Island = styled.aside(({ theme }) => ({
  '&&': {
    height: 'auto',
  },
  backgroundColor: theme.colors.white,
  border: `${theme.border.size['1']} solid ${theme.colors.gray500}`,
  borderRadius: theme.border.radius['12'],
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['16'],
  gridColumn: '-2 / -1',
  gridRow: 1,
  left: `calc(100% + ${theme.space['16']})`,
  padding: theme.space['16'],
  position: 'absolute',
  top: `calc(${COLUMN_HEADER_MIN_HEIGHT} + ${theme.space['12']})`,
  width: '22rem',
  zIndex: 3,
}))

export const Popover = styled.div(({ theme }) => ({
  ...getSwitchRows(theme),
  backgroundColor: theme.colors.white,
  border: `${theme.border.size['1']} solid ${theme.colors.gray500}`,
  borderRadius: theme.border.radius['12'],
  boxShadow: theme.shadow.md,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['16'],
  padding: theme.space['16'],
  width: '24rem',
  zIndex: theme.zIndex.level3,
}))

export const Content = styled.div(({ theme }) => ({
  ...getSwitchRows(theme),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['16'],
}))

export const Anchor = styled.span({
  display: 'inline-flex',
})
